<template>
  <div
    class="bg-img"
    :style="bgStyle"
  >
    <div class="anno-mask">
      <!-- 底图 -->
      <div class="anno">
        <div class="anno-title">
          <!-- 标题 -->
          <span class="anno-mainTitle">
            {{ $t("announcement.title") }}
          </span>
          <!-- 副标题 -->
          <span class="anno-subtitle">
            {{ $t("announcement.subTitle") }}
          </span>
        </div>
        <!-- 内容 -->
        <div class="anno-content">
          <span v-html="$t('announcement.content')"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 定时更换背景图
      switchTime: "2026-02-12 00:00:00",
      oldBgUrl: require("../assets/images/202510/home/bg.png"),
      newBgUrl: require("../assets/images/202602/home/bg.png"),
      timer: null,
      hasSwitched: false
    }
  },
  methods: {
    initBgSwitchTimer() {
      // 1. 转换指定时间为时间戳
      const targetTime = new Date(this.switchTime).getTime()
      // 2. 获取当前时间戳
      const nowTime = new Date().getTime()

      // 3. 计算时间差（毫秒）
      const timeDiff = targetTime - nowTime

      // 4. 判断是否需要设置定时器
      if (timeDiff <= 0) {
        // 如果当前时间已过指定时间，直接切换
        this.switchBackground()
      } else {
        // 否则设置单次定时器，到点后切换
        this.timer = setTimeout(() => {
          this.switchBackground()
        }, timeDiff)
      }
    },
    switchBackground() {
      if (!this.hasSwitched) {
        this.hasSwitched = true
      }
    }
  },
  computed: {
    bgStyle() {
      return {
        background: `url("${this.hasSwitched ? this.newBgUrl : this.oldBgUrl}") no-repeat center center / cover`,
      }
    }
  },
  mounted() {
    this.initBgSwitchTimer()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped lang="scss">
.bg-img {
  width: 1920px;
  height: 983px;
  // background-image: url("../assets/images/202602/home/bg.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: cover;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  position: relative;
  display: flex;
  justify-content: center;
}

.anno-mask {
  background: rgba(0, 0, 0, 0.8);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}

.anno {
  background-image: url("../assets/images/202602/announcement/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: flex;
  flex-direction: column;
  height: 90%;
  width: 90%;
  padding: 20px;
  box-sizing: border-box;
}

.anno-title {
  flex: 0 0 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  top: 50px;
}

.anno-mainTitle {
  font-family: "MiSans-Bold";
  font-size: 35px;
  font-weight: 700;
  display: flex;
  position: relative;
  width: 55%;
  align-items: center;
  justify-content: center;
}

.anno-subtitle {
  font-family: "MiSans-Bold";
  font-size: 30px;
  font-weight: 700;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}

.anno-content {
  display: flex;
  flex-direction: column;
  position: relative;
  top: 70px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-size: 18px;
  line-height: 1.4;
  font-family: "MiSans-Bold";
  width: 60%;
  box-sizing: border-box;
}
</style>
